/* ==========================================================================
   Virsaay — Card video
   A card rendered with show_video carries the product's clip over its photo.
   The clip plays muted while the card is on screen and pauses when it leaves;
   the frame only becomes visible once the clip is actually playing. Reaching
   for the detail thumbnails hands the frame back to the photos. Nothing plays
   under reduced motion or data saver.
   ========================================================================== */

(function () {
  'use strict';

  if (window.VirsaayCardVideo) return;
  window.VirsaayCardVideo = true;

  // The visitor's own setting only: VirsaayMotion.reduced is also true wherever
  // the scroll animations are switched off, which must not stop the clips.
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduced || saveData || !('IntersectionObserver' in window)) return;

  function play(video) {
    if (video._cardOff || !video._cardVisible) return;
    if (video.preload === 'none') video.preload = 'auto';
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      video._cardVisible = entry.isIntersecting;
      if (video._cardVisible) {
        play(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  }, { threshold: 0.5 });

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-card-video]'), function (video) {
      if (video._cardVideo) return;
      video._cardVideo = true;
      video.muted = true;

      var frame = video.parentNode;
      video.addEventListener('playing', function () { frame.classList.add('is-playing'); });
      video.addEventListener('pause', function () { frame.classList.remove('is-playing'); });

      var card = video.closest('[data-card]');
      var strip = card && card.querySelector('[data-card-detail-strip]');
      if (strip) {
        strip.addEventListener('pointerenter', function () {
          video._cardOff = true;
          video.pause();
        });
        card.addEventListener('pointerleave', function () {
          // A picked thumbnail keeps the photo; otherwise the clip resumes.
          if (card.classList.contains('is-detail-picked')) return;
          video._cardOff = false;
          play(video);
        });
      }

      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) { init(evt.target); });
})();
